import { WSText } from "@wingspanhq/fe-component-library";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { SetupFlowRouteComponentProps } from "../components/SetupFlow/SetupFlow";
import { PaymentsSetupLayout } from "../Invoices/components/PaymentsSetupLayout/PaymentsSetupLayout";
import { useUserId } from "../query/hooks/helpers";
import { usePaymentsStatusQuery } from "../query/payments/queries";
import { useAccounts, useActivities } from "../query/users/queries";
import { WSQueries } from "../query/WSQuery";
import { PayoutMethodsList } from "../Settings/components/PayoutMethodsList/PayoutMethodsList";

export const OnboarderEditPayouts: React.FC<SetupFlowRouteComponentProps> = () => {
  const userId = useUserId();

  const qActivities = useActivities(userId);
  const qPaymentsStatus = usePaymentsStatusQuery();
  const qAccounts = useAccounts();
  const history = useHistory();

  return (
    <PaymentsSetupLayout>
      <WSQueries queries={{ qActivities, qPaymentsStatus, qAccounts }}>
        {() => {
          return (
            <>
              <PayoutMethodsList basePath="/member/settings/payment-methods/payout-methods" />
            </>
          );
        }}
      </WSQueries>
    </PaymentsSetupLayout>
  );
};
